import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Switch   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import Modaladdcurriculumopen from './Modaladdcurriculumopen';
import Modeltest from './Modeltest';
import Modaladdteacher from './Modaladdteacher';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import ModalEditcurriculumopen from './ModalEditcurriculumopen';
import { api, URL } from '../../api';
import ModalReportstudent from './ModalReportstudent';




export default class Reportcurriculummooc extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
          switch1:true,
         
          type:'1',
        
          year:'2564',
          search: '',

          Course: [],
          Courseselect: [],
          Curriculumopen:[],
          Coursesearch: [],

        
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

      
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.onChangeswit = this.onChangeswit.bind(this);
        this.getsearch = this.getsearch.bind(this);
      }



        onChangeswit(checked,event) {

      //  console.log(`switch to ${checked}`);
      //  console.log(`switch to ${event.target.value}`);
   
        const datafrm = new FormData(); 

        if (checked === true) {
          datafrm.append("Curriculumopen_Status_ONOFF", '1') ;
        }else{
          datafrm.append("Curriculumopen_Status_ONOFF", '0') ;
        }
        datafrm.append("Curriculumopen_ID", event.target.value);
      
       // console.log(datafrm);
       api.post("index/updateCurriculumonoff/",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
              if (checked === true) {
                 Swal.fire({
                      title: 'เปิดหลักสูตรสำเร็จ',
                      icon: 'success',
                     // text: 'กรุณาลองอีกครั้ง',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
              } else {
                Swal.fire({
                  title: 'ปิดหลักสูตรสำเร็จ',
                  icon: 'success',
                 // text: 'กรุณาลองอีกครั้ง',
                // showCancelButton: true,
                  confirmButtonText: 'ตกลง',
                // cancelButtonText: 'No, keep it'
                }).then((result) => {
                
                })
                
              }   
        }) 
       }


        //ค้นหาหลักสูตรที่เปิดสอน
        getsearch(value) {
          setTimeout(() => {
           console.log(value)
            const Course = this.state.Course.filter( ({ Curriculumopen_ID }) => Curriculumopen_ID === value );
            this.setState({ Course });
           }, 0);
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
               console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
      }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 

         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }




          componentDidMount(){
           

            if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
            api.get('index/gettcurriculummooc/'+localStorage.getItem('Univ_ID'),
                      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                       //  console.log(res.data)
                        // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                       //  console.log(Course)
                          const Course = res.data;
                          this.setState({ Course });
                          const Coursesearch = res.data;
                          this.setState({ Coursesearch });

                         
                      })         
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };



       


    render() {

     //   console.log(this.state.Course_ID)
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const {  pagination } = this.state;
     
   
        const { Option } = Select;



               //ชุดตาราง
               const data = {
                columns: [
                  {
                    label: '#',
                    field: 'list',
                    sort: 'list',
                    width: 150
                  },
                  {
                    label: 'ปี',
                    field: 'Course_YEAR',
                    sort: 'Course_YEAR',
                    width: 150
                  },
                  {
                    label: 'ภาคเรียน',
                    field: 'Curriculumopen_TEAM',
                    sort: 'Curriculumopen_TEAM',
                    width: 270
                  },
                  {
                    label: 'ชื่อหลักสูตรภาษาไทย',
                    field: 'Curriculumopen_Full_Name_TH',
                    sort: 'Curriculumopen_Full_Name_TH',
                    width: 200
                  },
                  {
                    label: 'ชื่อหลักสูตรภาษาอังกฤษ',
                    field: 'Curriculumopen_Full_Name_EN',
                    sort: 'Curriculumopen_Full_Name_EN',
                    width: 100
                  },
                  {
                    label: 'จำนวนชั่วโมง',
                    field: 'Curriculumopen_CH',
                    sort: 'Curriculumopen_CH',
                    width: 150
                  },
                  {
                    label: 'วันเริ่ม',
                    field: 'Curriculumopen_Date_START',
                    sort: 'Curriculumopen_Date_START',
                    width: 150
                  },
                  {
                    label: 'วันสิ้นสุด',
                    field: 'Curriculumopen_Date_END',
                    sort: 'Curriculumopen_Date_END',
                    width: 150
                  },
                   {
                    label: 'หลักสูตร',
                    field: 'Cu',
                    sort: 'Cu',
                    width: 150
                  },
                  {
                    label: 'คณบดี',
                    field: 'Dean',
                    sort: 'Dean',
                    width: 150
                  },
                  {
                    label: 'เปิด/ปิด',
                    field: 'Curriculumopen_Date_END1',
                    sort: 'Curriculumopen_Date_END1',
                    width: 150
                  },
                 
                  {
                    label: 'แก้ไข',
                    field: 'Curriculumopen_EDIT',
                    sort: 'Curriculumopen_EDIT',
                    width: 150
                  }


                ],
      
                rows: [...this.state.Course.map((data, i) => (
                  {
                     list: <>{i+1}</>,
                     Course_YEAR: <>{data.Course_YEAR}</>,
                     Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                     Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}{data.Curriculumopen_Mook	==='1'?<>
                     <br/> (มีเปิดสอนใน KPRU MOOC)
                      </>:<></>}</>,
                     Curriculumopen_Full_Name_EN: <>{data.Curriculumopen_Full_Name_EN}</>,
                     Curriculumopen_CH: <>{data.Curriculumopen_CH}</>,
                     Curriculumopen_Date_START: <>{data.Curriculumopen_Date_START}</>,
                     Curriculumopen_Date_END: <>{data.Curriculumopen_Date_END}</>,
                     Cu: <>{data.Curriculumopen_Approve_Cu === '2'?<><p className="teal-text">อนุมัติ</p></>:<></>}</>,
                     Dean: <>{data.Curriculumopen_Approve_Dean === '2'?<><p className="teal-text">อนุมัติ</p></>:<></>}</>,

                   //  Curriculumopen_Date_END1: <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  />,
                     Curriculumopen_Date_END1: (()=> { 
                     return <center>  {data.Curriculumopen_Status_ONOFF === '1' ? <> <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  /> </>: <> <Switch value={data.Curriculumopen_ID} onClick={this.onChangeswit} /> </>}</center>
                      // if (<>data.Curriculumopen_Status_ONOFF === '1'</>) {
                      //   return <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  />
                      // }else{
                      // }
                      })(),
                      Curriculumopen_EDIT: (()=> { 
                        return <> <ModalEditcurriculumopen Curriculumopen_ID={data.Curriculumopen_ID} /> <ModalReportstudent Curriculumopen_ID={data.Curriculumopen_ID} Curriculumopen_Full_Name_TH={data.Curriculumopen_Full_Name_TH	}/></>
                         // if (<>data.Curriculumopen_Status_ONOFF === '1'</>) {
                         //   return <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  />
                         // }else{
                         // }
                         })(),


                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                    
     
                  }
                 ))]
                
            
            };
      
            const persons = <MDBDataTable
           // searching ={true}
            searchLabel="ค้นหา ชื่อหลักสูตร"
            striped
            bordered
            small 
            entries={20}
           // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={data}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            />
      //ชุดตาราง




       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
{/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> รายงานข้อมูลหลักสูตร MOOC</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >

       <MDBRow>
            <MDBCol sm="6">
            <label htmlFor="example2"><MDBIcon icon="search" /> ค้นหาหลักสูตร </label><br/>
            <Select
                    showSearch
                    style={{ width: 300 }}
                    placeholder="เลือกหลักสูตร"
                    optionFilterProp="children"
                    onChange={this.getsearch}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {/* <Option value="jack">Jack</Option>
                    <Option value="lucy">Lucy</Option>
                    <Option value="tom">Tom</Option> */}
                   
                   {this.state.Coursesearch.map((Course,index )  => 
                   <option value={Course.Curriculumopen_ID}>{Course.Curriculumopen_Full_Name_TH}</option>
                   )}
            </Select>
            </MDBCol>

            <MDBCol sm="4">
                 <div>
                 {/* <Modeltest/> */}
                 </div>
                    {/* <br/> */}
            </MDBCol> 
  </MDBRow>

<br/>
   

     <MDBRow>
          <MDBCol sm="12">
         
                      <MDBJumbotron fluid>
                        <MDBContainer fluid>
                        <h2 className="display-5 deep-purple-text text-center">ข้อมูลหลักสูตร MOOC</h2>
                            {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                            {/* <Table id="pdfdiv" columns={columns} dataSource={this.state.Curriculumopen} onChange={this.handleChange} responsive scroll={{ x: 1000 }}  pagination={{ pagination, showSizeChanger: true}}   />     */}
                            {/* <MDBTable small responsiveMd>
                                <MDBTableHead>
                                    <tr>
                                    <th>สำดับ</th>
                                    <th>ปี</th>
                                    <th>เทอม</th>
                                    <th>ชื่อหลักสูตรภาษาไทย</th>
                                    <th>ชื่อหลักสูตรภาษาอังกฤษ</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>วันเริ่ม</th>
                                    <th>วันสิ้นสุด</th>
                                    <th>จัดการ</th>
                                   
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.Course.map((Curriculumopen,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{Curriculumopen.Course_YEAR }</td>
                                    <td>{Curriculumopen.Curriculumopen_TEAM }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_TH }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_EN }</td>
                                    <td>{Curriculumopen.Curriculumopen_CH }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_START }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_END }</td>
                                    <td> 
                                    {Curriculumopen.Curriculumopen_Status_ONOFF === '1'?<><Switch  defaultChecked value={Curriculumopen.Curriculumopen_ID} onClick={this.onChangeswit}  /></>:<><Switch value={Curriculumopen.Curriculumopen_ID} onClick={this.onChangeswit} /></>}
                                    </td>
                                    
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable> */}

                            {persons} 

                          <h3>จำนวน {this.state.Course.length} หลักสูตร</h3>

                        </MDBContainer>
                        </MDBJumbotron>
                       
          </MDBCol>
     </MDBRow>

        </Card>

       
            </MDBContainer>
        )
    }
}
